<template>
  <div class="goods-edit">
    <div class="goods-edit__header">
      <div class="goods-edit__header__back">
        <router-link v-if="goodData" :to="`/goods?game=${goodData.game}`" class="goods-edit__backBtn">
          <img src="../../../assets/images/arrowLeft.svg" alt="back" />
          Назад к списку товаров
        </router-link>
      </div>
    </div>

    <div v-if="loading" class="goods-edit__loader">
      <Loader />
    </div>

    <div v-else-if="error" class="goods-edit__error">
      <h3>Ошибка загрузки товара</h3>
      <p>{{ error }}</p>
      <button @click="loadGoodDetails" class="goods-edit__retryBtn">
        Попробовать снова
      </button>
    </div>

    <div v-else-if="goodData" class="goods-edit__content">
      <div class="goods-edit__typeSelector">
        <h3>Выберите тип редактирования:</h3>
        <div class="goods-edit__typeButtons">
          <button
            @click="selectEditType('group')"
            :class="{ active: editType === 'group' }"
            class="goods-edit__typeBtn"
          >
            Редактировать группу
          </button>
          <button
            @click="selectEditType('variant')"
            :class="{ active: editType === 'variant' }"
            class="goods-edit__typeBtn"
          >
            Редактировать вариант
          </button>
        </div>
      </div>

      <goods-edit-form
        :goodData="goodData"
        :selectedGame="goodData.game"
        :loading="updateLoading"
        @submit="onSubmit"
        @cancel="onCancel"
        ref="editForm"
      />
    </div>
  </div>
</template>

<script>
import Loader from '../../../components/Loader/Loader.vue'
import GoodsEditForm from '../../../components/GoodsEditForm/GoodsEditForm.vue'
import { getGoodDetails, updateGoodVariant, updateGoodGroup } from '@/apis'

export default {
  name: 'GoodsEditView',
  components: { Loader, GoodsEditForm },
  data() {
    return {
      goodData: null,
      loading: true,
      updateLoading: false,
      error: null,
      editType: 'group'
    }
  },
  mounted() {
    this.loadGoodDetails()
  },
  methods: {
    async loadGoodDetails() {
      this.loading = true
      this.error = null
      
      try {
        const goodId = this.$route.params.goodId
        this.goodData = await getGoodDetails(goodId)
      } catch (error) {
        console.error('Error loading good details:', error)
        this.error = 'Не удалось загрузить данные товара. Проверьте правильность ID.'
      } finally {
        this.loading = false
      }
    },
    selectEditType(type) {
      this.editType = type
    },
    async onSubmit(requestData) {
      this.updateLoading = true
      try {
        if (this.editType === 'variant') {
          await updateGoodVariant(this.$route.params.goodId, requestData)
        } else {
          await updateGoodGroup(this.goodData.group_id, requestData)
        }
        
        this.$toast?.success('Товар успешно обновлен!')
        this.$router.push('/goods')
      } catch (error) {
        console.error('Error updating good:', error)
        this.$refs.editForm.generalError = 'Ошибка при обновлении товара. Попробуйте еще раз.'
      } finally {
        this.updateLoading = false
      }
    },
    onCancel() {
      this.$router.push(`/goods?game=${this.goodData.game}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.goods-edit {
  display: flex;
  flex-direction: column;
  gap: 15px;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__back {
      display: flex;
      align-items: center;
    }
  }

  &__backBtn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: #1a1f3e;
    border: 1px solid #646464;
    border-radius: 6px;
    padding: 10px 16px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;

    img {
      width: 16px;
      height: 16px;
      filter: brightness(0) invert(1);
    }

    &:hover {
      background: #2a2f4e;
      border-color: #7457ff;
    }
  }

  &__loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
  }

  &__error {
    background: #131732;
    border-radius: 8px;
    padding: 30px;
    border: 1px solid #ff4757;
    text-align: center;

    h3 {
      color: #ff4757;
      font-size: 20px;
      font-weight: 600;
      margin: 0 0 15px 0;
    }

    p {
      color: #ccc;
      font-size: 14px;
      margin: 0 0 20px 0;
    }
  }

  &__retryBtn {
    background: #7457ff;
    border: none;
    border-radius: 6px;
    padding: 10px 20px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: #6a4fd8;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  &__typeSelector {
    background: #131732;
    border-radius: 8px;
    padding: 20px;
    border: 1px solid #646464;

    h3 {
      color: white;
      font-size: 18px;
      font-weight: 600;
      margin: 0 0 15px 0;
    }
  }

  &__typeButtons {
    display: flex;
    gap: 15px;

    @media (max-width: 768px) {
      flex-direction: column;
    }
  }

  &__typeBtn {
    background: #1a1f3e;
    border: 1px solid #646464;
    border-radius: 6px;
    padding: 12px 20px;
    color: white;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      border-color: #7457ff;
    }

    &.active {
      background: #7457ff;
      border-color: #7457ff;
    }
  }
}
</style>
